<template>
  <div class="container">
    <div v-if="detail">
      <div class="content">
        <div class="header">
          <div class="header-img">
            <img :src="getImg(detail.avatar)" alt="" />
          </div>
          <div class="header-text">
            <div class="header-text-name">{{ detail.doctorName }}</div>
            <div class="header-text-dept">
              <i class="iconfont icon-si-glyph-man-doctor"></i
              >{{ detail.doctorTitle }}
            </div>
            <div class="header-text-dept">
              <i class="iconfont icon-my-department"></i>{{ detail.deptName }}
            </div>
          </div>
          <div class="follow-enabled" v-if="mark == 1" @click="delFollow">
            <van-icon name="star" />已关注
          </div>
          <div class="follow-disabled" v-if="mark == 0" @click="follow">
            <van-icon name="star-o" />关注
          </div>
        </div>
        <!-- <div class="detail-title">
          <i class="iconfont icon-class_waiting"></i> 预约挂号
          <span class="title-detail">预约线下门诊，无需窗口排队</span>
        </div> -->
        <div class="detail-content" v-if="status == 'selectDoctor'">
          <div class="detail-content-dept">
            <div class="name">{{ detail.OUTPATIENTSECTIONNAME }}</div>
            <div class="much">￥{{ docData.OWN_PRICE }}元/次</div>
          </div>
        </div>
        <div class="detail-content" v-if="status == 'docindex'">
          <van-radio-group v-model="radio" v-if="registeredList != ''">
            <div
              name="index"
              v-for="(item, index) in registeredList"
              :key="index"
              class="radioclass"
            >
              <div class="detail-content-dept">
                <div class="name">
                  {{ datefun(item.ADM_DATE) }}
                  {{
                    item.SESSION_CODE == '01'
                      ? '白天'
                      : item.SESSION_CODE == '02'
                      ? '晚上'
                      : item.SESSION_CODE == '04'
                      ? '上午'
                      : item.SESSION_CODE == '05'
                      ? '下午'
                      : item.SESSION_CODE == '06'
                      ? '全天'
                      : item.SESSION_CODE == '07'
                      ? '复诊'
                      : '复诊1'
                  }}
                </div>
                <div class="much">￥{{ item.OWN_PRICE }}元/次</div>
              </div>
            </div>
          </van-radio-group>
          <div v-else>该医生暂无排班</div>
        </div>
        <div class="detail-title"><i class="iconfont icon-home"></i> 擅长</div>
        <div class="detail-content">
          {{ detail.strengths }}
        </div>
        <div class="detail-title">
          <i class="iconfont icon-si-glyph-man-doctor"></i> 简介
        </div>
        <div class="detail-content">
          {{ detail.about }}
        </div>
      </div>
      <!-- <div class="footer" v-if="status == 'docindex' && registeredList != ''">
        <van-button round type="info" size="large" @click="goPatientList">预约挂号</van-button>
      </div> -->
    </div>
    <van-empty v-if="!detail" image="error" description="参数错误" />
  </div>
</template>

<script>
import { getBaseUrl } from '../../utils/request'
import {
  findByDoctor,
  addFollow,
  deleteFollow,
  getClassesInfoByUserId
} from '@/api/api'
import { Toast } from 'vant'
export default {
  data() {
    return {
      date: '',
      show: false,
      showTime: false,
      detail: {},
      docData: {},
      mark: 0,
      status: '',
      registeredList: '',
      radio: ''
    }
  },
  created() {},
  mounted() {
    this.status = this.$route.query.status
    if (this.status == 'selectDoctor') {
      this.docData = JSON.parse(this.$route.query.docCode)
      this.getData(JSON.parse(this.$route.query.docCode).DR_CODE)
    } else if (this.status == 'docindex') {
      this.docData = JSON.parse(this.$route.query.docCode)
      this.getData(JSON.parse(this.$route.query.docCode).doctorCode)
      getClassesInfoByUserId(
        JSON.parse(this.$route.query.docCode).doctorCode
      ).then(res => {
        if (res.code == 200) {
          this.registeredList = JSON.parse(res.data)
        }
      })
    }
  },
  methods: {
    getImg(url) {
      if (url) return getBaseUrl() + url
      else return require('@/assets/head.jpg')
    },
    getData(code) {
      findByDoctor(code).then(res => {
        this.detail = res.data
        if (res.msg == '0') {
          this.mark = 1
        } else {
          this.mark = 0
        }
      })
    },
    selectDoctor() {
      this.show = !this.show
    },
    goPatientList() {
      if (this.status == 'selectDoctor') {
        this.docData['selectPeople'] = 'select'
        this.$router.push({
          name: 'patientList',
          query: this.docData
        })
      } else if (this.status == 'docindex') {
        this.registeredList[this.radio]['selectPeople'] = 'select'
        this.$router.push({
          name: 'patientList',
          query: this.registeredList[this.radio]
        })
      }
    },
    delFollow() {
      deleteFollow(this.detail.doctorCode).then(res => {
        if (res.code == 200) {
          Toast.success('取消关注成功')
          this.mark = 0
        } else {
          Toast.fail('取消关注失败')
        }
      })
    },
    follow() {
      addFollow(this.detail.doctorCode).then(res => {
        if (res.code == 200) {
          Toast.success('关注成功')
          this.mark = 1
        } else {
          Toast.fail('关注失败')
        }
      })
    },
    datefun(datecode) {
      let datecodeStr = String(datecode)
      if (datecodeStr.length == 8) {
        return (
          datecodeStr.slice(0, 4) +
          '-' +
          datecodeStr.slice(4, 6) +
          '-' +
          datecodeStr.slice(6, 8)
        )
      } else {
        return datecode
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  width: 100vw;
}

.content {
  width: 100vw;
  height: calc(100vh - 55px);
  background: rgb(242, 248, 253);

  .header {
    width: 100vw;
    height: 37vw;
    background: url('../../assets/header.jpg');
    padding: 25px;
    display: flex;
    align-items: center;
    position: relative;

    .follow-enabled {
      position: absolute;
      right: 25px;
      top: 30px;
      font-size: 13px;
      width: 65px;
      height: 20px;
      color: rgb(8, 112, 253);
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
    }

    .follow-disabled {
      position: absolute;
      right: 25px;
      top: 30px;
      font-size: 13px;
      width: 65px;
      height: 20px;
      color: rgb(8, 112, 253);
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
    }

    .header-img {
      width: 20vw;
      height: 20vw;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 2px solid #fff;
      }
    }

    .header-text {
      width: calc(100% - 20vw);
      height: 20vw;
      color: #fff;
      padding-left: 15px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      &-name {
        font-size: 18px;
      }

      &-dept {
        font-size: 12px;
        i {
          margin-right: 10px;
        }
      }
    }
  }

  .detail-title {
    width: 100vw;
    background: #fff;
    height: 45px;
    display: flex;
    align-items: center;
    padding: 0 15px;
    border-bottom: 1px solid rgb(234, 234, 234);

    i {
      color: rgb(102, 181, 251);
      margin-right: 10px;
    }

    .title-detail {
      color: #666;
      font-size: 14px;
      margin-left: 13px;
    }
  }

  .detail-content {
    padding: 10px 15px;
    width: 100vw;
    color: #666;
    margin-bottom: 15px;
    background: #fff;
    font-size: 13px;

    &-dept {
      display: flex;
      justify-content: space-between;
      height: 30px;
      align-items: center;
      width: 80vw;

      .name {
        font-size: 15px;
        color: #000;
      }

      .much {
        font-size: 15px;
        color: rgb(237, 125, 84);
      }
    }

    &-time {
      display: flex;

      .time-label {
        font-size: 14px;
        width: 22vw;
        color: #000;
      }

      .time-select {
        width: calc(100% - 22vw);
        display: flex;
        flex-flow: wrap;

        .select-item {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 25px;
          width: 22vw;
          border-radius: 12.5px;
          background: rgb(240, 240, 240);
          color: #000;
          font-size: 12px;
          margin: 0 5px 5px 0;
        }
      }
    }
  }
}

.footer {
  width: 100vw;
  height: 55px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 15px;
}

.popue-flex {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
}

.popup-content {
  height: 120px;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;

  &-item {
    width: 100%;
    padding: 5px 10px;
    height: 40px;
    font-size: 14px;
    color: #666;
    display: flex;
    align-items: flex-end;

    .name {
      font-size: 16px;
      color: #000;
      padding-right: 10px;
    }

    .item-time {
      width: 80px;
      height: 20px;
      border-radius: 10px;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgb(240, 240, 240);

      &-active {
        width: 80px;
        height: 20px;
        border-radius: 10px;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgb(8, 112, 253);
        color: #fff;
      }
    }
  }
}

.popup-do {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-top: 1px solid rgb(234, 234, 234);

  .do-cancel {
    color: #000;
    height: 60%;
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid rgb(234, 234, 234);
  }

  .do-enter {
    color: rgb(8, 112, 253);
    height: 60%;
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid rgb(234, 234, 234);
  }
}

@font-face {
  font-family: 'iconfont';
  src: url('data:font/truetype;charset=utf-8;base64,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')
    format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.iconfont {
  font-family: 'iconfont' !important;
  font-size: 14px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-my-department:before {
  content: '\e70a';
}

// students
.icon-home:before {
  content: '\e501';
}

.icon-class_waiting:before {
  content: '\e6f5';
}

.icon-si-glyph-man-doctor:before {
  content: '\e6b4';
}

.radioclass {
  width: 90vw;
}
</style>
